// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-webmap-layers-tree.ant-tree .ant-tree-treenode {
  padding: 0;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-treenode.ant-tree-treenode-selected {
  background-color: #e6f0f800;
}
.ngw-webmap-layers-tree.ant-tree:not(.ant-tree-show-line) .ant-tree-switcher-noop {
  width: 6px;
}
.ngw-webmap-layers-tree.ant-tree.ant-tree-show-line .ant-tree-indent-unit {
  width: 18px;
}
.ngw-webmap-layers-tree.ant-tree.ant-tree-show-line .ant-tree-indent-unit::before {
  right: 6px;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-checkbox {
  top: initial;
  margin-inline-end: 0px;
  align-self: flex-start;
  margin-top: 4px;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper:hover {
  background: transparent;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper .ant-row {
  margin: 0;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper .ant-tree-icon__customize img {
  vertical-align: text-top;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper .ant-tree-title {
  width: 100%;
  min-width: 0;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper .ant-tree-title .tree-item-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper .ant-tree-title .tree-item-title .legend-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper .ant-tree-title .tree-item-action {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.ngw-webmap-layers-tree.ant-tree .ant-tree-node-content-wrapper .ant-tree-title:hover {
  background: #ffffff00;
  border-radius: 3px;
  color: #000000;
}
.tree-item-menu .ant-dropdown-menu-title-content {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 5px;
  align-items: center;
}
:where(.css-dev-only-do-not-override-1j0bb9m).ant-tree .ant-tree-node-content-wrapper:hover,
:where(.css-dev-only-do-not-override-1j0bb9m).ant-tree .ant-tree-checkbox + span:hover {
  background-color: #ffffff00;
}
.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle {
  font-size: 24px;
  color: #106a90;
  width: 24px;
  height: 24px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  margin: 0 6px;
}
.icon-not-active {
  background-color: #00000000 !important;
  cursor: auto;
}
.titleName {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  padding: 0 0 0 5px;
  font-size: small;
  width: 100%;
}
.titleName:hover {
  background: #f7f7f7;
  border-radius: 3px;
}
.ant-tree .ant-tree-treenode {
  align-items: center;
  display: flex;
  outline: none;
  padding: 0;
  margin: 3px 0;
}
.iconCustom {
  display: flex;
  align-items: center;
  padding: 0 4px;
}
.legend-list {
  margin: 0 5px 0 5px;
}
.more,
.legend {
  font-size: 18px;
  color: #106a90;
  width: 24px;
  height: 24px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}
.colSingleIconLegend {
  margin: 0;
}
.colSingleIconLegend:hover {
  color: #106a90;
  border: #106a90 solid 1px;
  border-radius: 3px;
  margin: -1px;
}
.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle,
.ant-tree .ant-tree-checkbox + span .ant-tree-iconEle {
  display: flex;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: top;
  align-items: center;
}
.iconSingle {
  display: flex;
}
.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected,
.ant-tree .ant-tree-checkbox + span.ant-tree-node-selected {
  background-color: #ffffff00;
}
.ant-tree .ant-tree-switcher-leaf-line:before {
  position: absolute;
  top: -10px;
  inset-inline-end: 12px;
  bottom: -11px;
  margin-inline-start: -1px;
  border-inline-end: 1px solid #d9d9d9;
  content: "";
}
.ant-tree-show-line .ant-tree-indent-unit:before {
  position: absolute;
  top: -10px;
  inset-inline-end: 12px;
  bottom: -10px;
  border-inline-end: 1px solid #d9d9d9;
  content: "";
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/layers-tree/LayersTree.less"],"names":[],"mappings":"AAAA;EAEQ,UAAA;AAAR;AAEQ;EACI,2BAAA;AAAZ;AAII;EACI,UAAA;AAFR;AAKI;EAEQ,WAAA;AAJZ;AAMY;EACI,UAAA;AAJhB;AAdA;EAwBQ,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AAPR;AApBA;EA+BQ,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AARR;AAUQ;EACI,uBAAA;AARZ;AA7BA;EAyCY,SAAA;AATZ;AAhCA;EA8CgB,wBAAA;AAXhB;AAnCA;EAmDY,WAAA;EACA,YAAA;AAbZ;AAvCA;EAuDgB,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAbhB;AA9CA;EA8DoB,gBAAA;EACA,uBAAA;EACA,mBAAA;AAbpB;AAnDA;EAqEgB,aAAA;EACA,mBAAA;EACA,oBAAA;AAfhB;AAkBY;EACI,qBAAA;EACA,kBAAA;EACA,cAAA;AAhBhB;AAuBA;EAEQ,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;AAtBR;AA0BA;;EACI,2BAAA;AAvBJ;AA0BA;EACI,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAxBJ;AA4BA;EACI,sCAAA;EACA,YAAA;AA1BJ;AA6BA;EACI,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AA3BJ;AA6BI;EACI,mBAAA;EAEA,kBAAA;AA5BR;AAgCA;EACI,mBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;AA9BJ;AAiCA;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AA/BJ;AAkCA;EACI,mBAAA;AAhCJ;AAmCA;;EAEI,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAjCJ;AAsCA;EACI,SAAA;AApCJ;AAsCI;EACI,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AApCR;AAwCA;;EAEI,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAtCJ;AAyCA;EACI,aAAA;AAvCJ;AA0CA;;EAEI,2BAAA;AAxCJ;AA2CA;EACI,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,oCAAA;EACA,WAAA;AAzCJ;AA4CA;EACI,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;AA1CJ","sourcesContent":[".ngw-webmap-layers-tree.ant-tree {\n    .ant-tree-treenode {\n        padding: 0;\n\n        &.ant-tree-treenode-selected {\n            background-color: #e6f0f800;\n        }\n    }\n\n    &:not(.ant-tree-show-line) .ant-tree-switcher-noop {\n        width: 6px;\n    }\n\n    &.ant-tree-show-line {\n        .ant-tree-indent-unit {\n            width: 18px;\n\n            &::before {\n                right: 6px;\n            }\n        }\n    }\n\n    .ant-tree-checkbox {\n        top: initial;\n        margin-inline-end: 0px;\n        align-self: flex-start;\n        margin-top: 4px;\n    }\n\n    .ant-tree-node-content-wrapper {\n        display: flex;\n        width: 100%;\n        min-width: 0;\n        align-items: center;\n\n        &:hover {\n            background: transparent;\n        }\n\n        .ant-row {\n            margin: 0;\n        }\n\n        .ant-tree-icon__customize {\n            img {\n                vertical-align: text-top;\n            }\n        }\n\n        .ant-tree-title {\n            width: 100%;\n            min-width: 0;\n\n            .tree-item-title {\n                min-width: 0;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                display: flex;\n\n                .legend-title {\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                }\n            }\n\n            .tree-item-action {\n                display: flex;\n                flex-direction: row;\n                justify-content: end;\n            }\n\n            &:hover {\n                background: #ffffff00;\n                border-radius: 3px;\n                color: #000000;\n            }\n\n        }\n    }\n}\n\n.tree-item-menu {\n    .ant-dropdown-menu-title-content {\n        display: flex;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        gap: 5px;\n        align-items: center;\n    }\n}\n\n:where(.css-dev-only-do-not-override-1j0bb9m).ant-tree .ant-tree-node-content-wrapper:hover, :where(.css-dev-only-do-not-override-1j0bb9m).ant-tree .ant-tree-checkbox+span:hover {\n    background-color: #ffffff00;\n}\n\n.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle {\n    font-size: 24px;\n    color: #106a90;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    justify-items: center;\n    justify-content: center;\n    align-items: center;\n    margin: 0 6px;\n}\n\n\n.icon-not-active {\n    background-color: #00000000 !important;\n    cursor: auto;\n}\n\n.titleName {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n    white-space: nowrap;\n    padding: 0 0 0 5px;\n    font-size: small;\n    width: 100%;\n\n    &:hover {\n        background: rgba(247, 247, 247, 1);\n        // padding: 2px;\n        border-radius: 3px;\n    }\n}\n\n.ant-tree .ant-tree-treenode {\n    align-items: center;\n    display: flex;\n    outline: none;\n    padding: 0;\n    margin: 3px 0;\n}\n\n.iconCustom {\n    display: flex;\n    align-items: center;\n    padding: 0 4px;\n}\n\n.legend-list {\n    margin: 0 5px 0 5px;\n}\n\n.more,\n.legend {\n    font-size: 18px;\n    color: #106a90;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    justify-items: center;\n    justify-content: center;\n    align-items: center;\n    flex: 0 0 auto;\n\n\n}\n\n.colSingleIconLegend {\n    margin: 0;\n\n    &:hover {\n        color: #106a90;\n        border: #106a90 solid 1px;\n        border-radius: 3px;\n        margin: -1px;\n    }\n}\n\n.ant-tree .ant-tree-node-content-wrapper .ant-tree-iconEle,\n.ant-tree .ant-tree-checkbox+span .ant-tree-iconEle {\n    display: flex;\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n    text-align: center;\n    vertical-align: top;\n    align-items: center;\n}\n\n.iconSingle {\n    display: flex;\n}\n\n.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected,\n.ant-tree .ant-tree-checkbox+span.ant-tree-node-selected {\n    background-color: #ffffff00;\n}\n\n.ant-tree .ant-tree-switcher-leaf-line:before {\n    position: absolute;\n    top: -10px;\n    inset-inline-end: 12px;\n    bottom: -11px;\n    margin-inline-start: -1px;\n    border-inline-end: 1px solid #d9d9d9;\n    content: \"\";\n}\n\n.ant-tree-show-line .ant-tree-indent-unit:before {\n    position: absolute;\n    top: -10px;\n    inset-inline-end: 12px;\n    bottom: -10px;\n    border-inline-end: 1px solid #d9d9d9;\n    content: \"\";\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
